export default "__VITE_ASSET__TwJsbCd5__"